import React from 'react';
import { basePath } from '@routes';
import { type UserMenuItemExtensionParams } from '@sharefiledev/appshell-menu-pilet-sdk';
import { t } from '@utils/translate';

export const NavigationMenuItem: React.FC<UserMenuItemExtensionParams> = ({
	registerUserMenuItem,
}) => {
	React.useEffect(
		() => {
			registerUserMenuItem({
				key: 'catalog',
				label: t('titles.navbar'),
				url: basePath,
				newTab: true,
				analyticsId: 'UserMenu_CatalogButton',
			});
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[]
	);

	return null;
};
